module.exports = __webpack_public_path__ + "media/images/icon__profile@2x-c904cd8a799e6ff0f59d2ff73f6620dc.png";